module.exports = require("tls");


//////////////////
// WEBPACK FOOTER
// external "tls"
// module id = 121
// module chunks = 0 1